import * as React from 'react';
import './ReturnsRmaRow.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IReturnDetail } from 'src/services/returns/typings';
import isNumber from 'src/utils/isNumber';
import hasComma from 'src/utils/hasComma';
import { RMA_EDIT } from 'src/pages/ReturnsView/ReturnsView';
import IconMessage from 'src/components/common/IconMessage';
import i18n from 'src/translation/i18n';

interface IReturnsRmaRowProps {
  rmaItem: IReturnDetail;
  rmaItemFixed: IReturnDetail;
  action: string;
  handleChangeRmaData: (id: number) => void;
  handleChangeRmaDataInput: (value: IReturnDetail[]) => void;
  rmaData: IReturnDetail[];
}

const ReturnsRmaRow: React.FC<IReturnsRmaRowProps> = props => {
  const {
    rmaItem,
    action,
    handleChangeRmaData,
    rmaData,
    handleChangeRmaDataInput,
    rmaItemFixed
  } = props;
  const [returnQty, setReturnQty] = React.useState<string>(
    String(rmaItem.returnQuantity)
  );
  const [reason, setReturnReason] = React.useState<string>(rmaItem.reason);

  React.useEffect(() => {
    const newRmaData = rmaData.map(rmaD => {
      if (rmaD.id === rmaItem.id) {
        return {
          ...rmaD,
          reason,
          returnQuantity: Number(returnQty)
        };
      } else {
        return rmaD;
      }
    });

    handleChangeRmaDataInput(newRmaData);
  }, [returnQty, reason]);

  const handleChangeReturnQty = (e: any) => {
    const qty = e.target.value;

    if (
      isNumber(qty) &&
      qty <= rmaItemFixed.returnQuantity + rmaItem.quantity
    ) {
      setReturnQty(qty);
    }
  };

  const handleChangeReason = (e: any) => {
    if (!hasComma(e.target.value)) {
      setReturnReason(e.target.value);
    }
  };

  return (
    <div className="rp-returns-rma-row">
      <div className="container-fluid">
        <div className="row rp-returns-rma-row-grid">
          <div className="d-flex align-items-center col-16">
            <p className="rp-returns-rma-row-container">{rmaItem.partNumber}</p>
          </div>
          <div className="d-flex align-items-center col-14">
            <p className="rp-returns-rma-row-container">
              {rmaItem.invoiceNumber}
            </p>
          </div>
          <div className="d-flex align-items-center col-9">
            <p className="rp-returns-rma-row-container price">
              {localeFormatingInstance.formatCurrency(rmaItem.price)}
            </p>
            {rmaItem.hasCoreIncluded && (
              <IconMessage
                icon={'rpds-error'}
                isIconInline={true}
                message={'This price includes a Core Charge'}
              />
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center col-11">
            {action === RMA_EDIT ? (
              <>
                <input
                  value={returnQty}
                  onChange={handleChangeReturnQty}
                  className="rp-returns-rma-row-container-input price"
                  type="text"
                />
                <p className="rp-returns-rma-row-container-return-quantity-total">
                  / {rmaItem.quantity + rmaItemFixed.returnQuantity}
                </p>
              </>
            ) : (
              <p className="rp-returns-rma-row-container">
                {rmaItem.returnQuantity}
              </p>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center col-12">
            <p className="rp-returns-rma-row-container">
              {rmaItem.restockingFee}%
            </p>
          </div>
          <div className="d-flex align-items-center justify-content-center col-12">
            <p className="rp-returns-rma-row-container">
              {localeFormatingInstance.formatCurrency(rmaItem.returnAmount)}
            </p>
          </div>
          <div className="d-flex align-items-center col-17">
            {action === RMA_EDIT ? (
              <input
                value={reason}
                onChange={handleChangeReason}
                className="rp-returns-rma-row-container-input"
                type="text"
                maxLength={60}
              />
            ) : (
              <p className="rp-returns-rma-row-container">{rmaItem.reason}</p>
            )}
          </div>
          <div className="d-flex align-items-center d-flex justify-content-end col-9">
            <div className="rp-returns-rma-row-buttons">
              <div
                className="rp-returns-rma-row-button-remove"
                onClick={() => handleChangeRmaData(rmaItem.id)}
              >
                <i className="rpds-remove-circle rp-returns-rma-row-button-icon" />
                <p className="rp-returns-rma-row-button-text">
                  {i18n.t('common.removeAction')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {!rmaItem.isValid && (
          <div className="row d-flex justify-content-end">
            <div className="col-md-12 rp-returns-rma-row-longer-available">
              <p>
                <i className="rpds-error" />{' '}
                {/* {i18n.t('myReturns.rmaNoItemDisclaimerTxt')} */}
                {rmaItem.noOfDays
                  ? i18n.t('myReturns.rmaNoItemDisclaimerTxt', {
                      noOfDays: rmaItem.noOfDays
                    })
                  : i18n.t('myReturns.rmaNoItemDisclaimerTxtnodays')}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnsRmaRow;
